module.exports = __webpack_public_path__ + "media/Shipping_OUT.2bdbb923.mp4";